import * as React from 'react';
import { ReadOnlyContext } from './ReadOnlyContext';
export const useReadOnly = sectionName => {
  const {
    sections,
    setReadOnly,
    toggleReadOnly
  } = React.useContext(ReadOnlyContext);
  return {
    readOnly: sectionName ? sections[sectionName] :
    // when no sectionName: false if one section is not readOnly
    !Object.keys(sections).some(key => !sections[key]),
    setReadOnly,
    toggleReadOnly
  };
};